module.exports = __webpack_public_path__ + "static/media/customers.d9a04573.png";